import { BASE_URL } from './constant';

export const getImageURL = (pathname: string): string => `${BASE_URL}${pathname}`;

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
};
